import { Accordion, List } from '@chakra-ui/react'
import React from 'react'
import { Item } from './Item'
import { useOrcamentoPedido } from '../../../contexts/OrcamentoPedidoProvider'
import { Skeleton } from './styles'

export const ListItem = ({
  listItems,
  numero_nota,
  cliente,
  email_parceiro,
  telefone_parceiro,
  nome_parceiro,
  codigo_vendedor,
  nome_vendedor,
  num_proposta,
}) => {
  const referenceLastItem = React.useRef(null)
  const { isLoading, pedidoBloqueado } = useOrcamentoPedido()

  const [expandedItemId, setExpandedItemId] = React.useState(null)

  const handleAccordionToggle = (itemId) => {
    setExpandedItemId(itemId === expandedItemId ? null : itemId)
  }

  if (isLoading) {
    return (
      <List spacing={3}>
        {Array.from({ length: 2 }).map((_, index) => (
          <Skeleton width="1335px" height="155px" key={index} />
        ))}
      </List>
    )
  }

  return (
    <List spacing={3} pointerEvents={pedidoBloqueado ? 'none' : 'auto'}>
      <Accordion allowToggle>
        {listItems?.map((item, index) => (
          <Item
            key={item?.id}
            index={index + 1}
            item={item}
            isExpanded={expandedItemId === item?.id}
            onToggle={() => handleAccordionToggle(item?.id)}
            numero_nota={numero_nota}
            cliente={cliente}
            email_parceiro={email_parceiro}
            telefone_parceiro={telefone_parceiro}
            nome_parceiro={nome_parceiro}
            codigo_vendedor={codigo_vendedor}
            nome_vendedor={nome_vendedor}
            num_proposta={num_proposta}
          />
        ))}

        <div style={{ opacity: 0, height: '300px' }} ref={referenceLastItem}></div>
      </Accordion>
    </List>
  )
}
